import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import SearchIcon from '@material-ui/icons/Search';
import { get as _get } from 'lodash';
import React from 'react';
import { connect, useDispatch } from 'react-redux';
import { reduxStateMap, withReducerName } from '../redux/reduxMap';
import { saveInputValueToRedux } from '../redux/registryActions';

const useStyles = makeStyles((theme) => ({
    searchIcon: {
        opacity: 0.8,
        marginRight: 12,
        zoom: 1.2
    },
    input: {
        width: '100%',
        fontWeight: 600,
        fontSize: 16,
        letterSpacing: 1.2,
        height: '60px !important',
        '& .MuiOutlinedInput-notchedOutline': {
            borderWidth: '2px !important',
            borderColor: 'rgba(0, 0, 0, 0.4)'
        }
    },
    textField: {
        width: '100%',
        minWidth: 0
    }
}));

export default connect((state) => ({ searchTerm: _get(state, withReducerName(reduxStateMap.SEARCH_TERM)) }))(function SearchInput({ searchTerm }) {
    const classes = useStyles();
    const dispatch = useDispatch();

    return (
        <TextField
            label="Rekisteritunnus tai VIN"
            placeholder="ABC-123"
            variant="outlined"
            inputProps={{ maxLength: 30 }}
            InputProps={{ startAdornment: <SearchIcon className={classes.searchIcon} />, className: classes.input }}
            onChange={(e) => dispatch(saveInputValueToRedux('searchTerm', e.target.value))}
            value={searchTerm}
            className={classes.textField}
        />
    );
});
